/**
 * Thin top progress bar instead of vue-loading-overlay's full-page modal spinner.
 * Route changes and this.$loading.show() share one counter so the bar does not flicker.
 *
 * route: true keeps a content skeleton until the new page's first fetch also settles
 * (covers the gap between router.afterEach and mounted() $loading.show()).
 */

import Vue from 'vue'

let count = 0;
let bar = null;
let hideTimer = null;
let routeLock = false;

export const navLoading = Vue.observable({
    bar: false,
    route: false,
    data: false,
});

function syncHtml() {
    const root = document.documentElement;
    if (!root) {
        return;
    }
    root.classList.toggle('sip-nav-loading', navLoading.bar);
    root.classList.toggle('sip-route-loading', navLoading.route);
    root.classList.toggle('sip-data-loading', navLoading.data);
}

function applyState(next) {
    navLoading.bar = !!next.bar;
    navLoading.route = !!next.route;
    navLoading.data = !!next.data;
    syncHtml();
}

function ensureBar() {
    if (bar && bar.parentNode) {
        return bar;
    }
    bar = document.getElementById('sip-nprogress');
    if (!bar) {
        bar = document.createElement('div');
        bar.id = 'sip-nprogress';
        bar.setAttribute('aria-hidden', 'true');
        const parent = document.body || document.documentElement;
        parent.appendChild(bar);
    }
    return bar;
}

export function startNavProgress(opts) {
    if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
    }
    count += 1;
    if (opts && opts.route) {
        routeLock = true;
    }
    const el = ensureBar();
    el.classList.add('is-active');
    applyState({
        bar: true,
        route: routeLock,
        data: true,
    });
}

export function stopNavProgress() {
    count = Math.max(0, count - 1);
    if (count > 0) {
        applyState({
            bar: true,
            route: routeLock,
            data: true,
        });
        return;
    }
    if (hideTimer) {
        clearTimeout(hideTimer);
    }
    hideTimer = setTimeout(function () {
        hideTimer = null;
        if (count > 0) {
            return;
        }
        routeLock = false;
        if (bar) {
            bar.classList.remove('is-active');
        }
        applyState({ bar: false, route: false, data: false });
    }, 140);
}

export function installFastLoading(VueCtor) {
    const api = {
        show() {
            startNavProgress();
            let hidden = false;
            return {
                hide() {
                    if (hidden) {
                        return;
                    }
                    hidden = true;
                    stopNavProgress();
                }
            };
        }
    };
    VueCtor.$loading = api;
    VueCtor.prototype.$loading = api;
}

export function hideBootShell() {
    if (typeof window.sipHideSplash === 'function') {
        window.sipHideSplash();
    }
}
